module.exports = __webpack_public_path__ + "static/media/calendar.11f0265f.png";